import { TrimEditableImage } from '../../image-edit/trim.editable-image';
import { ITrimEditorManagerBase } from '../../trim-editor.manager';
import { UuidGenerator } from '../../../../utilities/uuid-generator';
import { XmlStructureModel } from '../../../../xml/model/xml-structure-model';
import { Env } from '../../../../models/env';
import { TrimCjBitmap, TrimCjContainer, TrimCjShape, TrimCjStage } from '../../../model/cj-factory';
import { TrimPrintManager } from '../../../print/trim.print';
import { TrimAdditionalManager } from '../../additional/trim.additional.manager';
import { TrimUiManager } from '../../ui/trim.ui.manager';
import createjs from 'createjs-module';
import { store } from '../../../../app/store';
import { CJ_BGIMAGE_NAME, CJ_CONTAINER_NAME } from '../../../model/cj-factory/trim.cj-obj-name.collection';
import { layoutActions } from '../../../../slices/layout-slice';
import { ThumbImageCreator } from './creator/thumb.image.creator';
import { ThumbTempCreator } from './creator/thumb.temp.creator';
import { TrimTempModel } from '../../../model/trim.temp-model';
import { PrintBase } from '../../../model/trim.print-model';
import { TrimEditableImageManager } from '../../editable-image/trim.editable-image.manager';
import { PrintTrimMenuType } from '../../../../components/pages/sift/print-trim/hooks/use-print-trim';
import { ThumbTextCreator } from './creator/thumb.text.creator';
import { TrimWebFontManager } from '../../web-font/trim.web-font.manager';
import { TrimFontManager } from '../../font/trim.font.manager';
import { ThumbRequestParam } from '../trim.thumb.manager';
import { NO_EDGE_TYPE } from '../../image-edit/frame/trim.frame-controller';

export type PathType = {
  base: string,
  ad: string,
  name: string,
}

type GetEditableImageParam = {
  editableImage: TrimEditableImage;
  index: number;
}

export class ThumbCreatorManager implements ITrimEditorManagerBase {
  // canvasの生成用data
  private readonly CANVAS_ID = UuidGenerator.create();
  static readonly CANVAS_W = 4000;
  static readonly CANVAS_H = 4000;
  // wrapperContainerの初期位置
  static readonly STAGE_CONTAINER_BASE_X = 2000;
  static readonly STAGE_CONTAINER_BASE_Y = 2000;
  public STAGE_CONTAINER_X = 2000;
  public STAGE_CONTAINER_Y = 2000;
  static readonly IMAGE_MAX_SIZE = 4000;
  public templateVirtual = {
    w: 0,
    h: 0,
  };
  public templateReal = {
    w: 0,
    h: 0,
  };
  public templateBaseVirtual = {
    w: 0,
    h: 0,
  };
  public templateBaseReal = {
    w: 0,
    h: 0,
  };
  public kijshopCd = '';
  public shopOrderId = '';
  public orderId = '';
  public xml: XmlStructureModel | null = null;
  public isAdditionalFrame: boolean = false;
  public isDAI: boolean = false;
  private isCompThumb: boolean = false;
  // private readonly BASE_URL = 'https://mercury.marietta.co.jp/share/labonet/template/';
  private readonly BASE_URL = `${Env.api.back.protocol}://${Env.api.back.host}/files/template`;

  // private readonly canvasWidth: number;
  // private readonly canvasHeight: number;

  private readonly canvas: HTMLCanvasElement;
  private wrapperStage: TrimCjStage | null;
  public stage: TrimCjContainer | null;

  private printManager!: TrimPrintManager;
  private thumbImageCreator!: ThumbImageCreator;
  private thumbTempCreator!: ThumbTempCreator;
  private thumbTextCreator!: ThumbTextCreator;
  private additionalManager: TrimAdditionalManager = new TrimAdditionalManager();
  private trimWebFontManager: TrimWebFontManager = new TrimWebFontManager();
  private trimFontManager: TrimFontManager = TrimFontManager.ins;

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas
    this.wrapperStage = null;
    this.stage = null;
  }

  initialize() {
  }

  destroy(): void {
    // if (!this.container) return;
    // // - DOM のリセット -
    // this.deleteCanvasEle(this.container);
    // listener 削除
    // this.cjCanvas?.removeAllEventListeners();
    // this.editableSideTool.transparentAdditional('show');

    this.wrapperStage?.removeAllEventListeners();
    this.stage?.removeAllEventListeners();
    createjs.Ticker.removeAllEventListeners();
    this.thumbImageCreator.destroy();
    this.thumbTempCreator.destroy();
    this.thumbTextCreator.destroy();
    this.trimWebFontManager.destroy();
    this.stage?.removeAllChildren()
    this.STAGE_CONTAINER_X = 2000;
    this.STAGE_CONTAINER_Y = 2000;
  }

  di(): void {}

  // async initStage(param: {
  //   kijshopCd: string,
  //   shopOrderId: string,
  //   orderId: string,
  //   printMng: TrimPrintManager,
  // }) {
  async initStage(param: ThumbRequestParam & {
    printMng: TrimPrintManager,
  }) {
    const {kijshopCd, shopOrderId, orderId, isCompThumb, printMng} = param;
    this.kijshopCd = kijshopCd;
    this.shopOrderId = shopOrderId;
    this.orderId = orderId;
    this.printManager = printMng;
    this.isCompThumb = !!isCompThumb;
    this.createCanvasEle();
    // const canvas = this.getCanvasEle();
    this.canvas!.width = ThumbCreatorManager.CANVAS_W;
    this.canvas!.height = ThumbCreatorManager.CANVAS_H;
    // this.container.appendChild(canvas);
    // container.appendChild(this.canvas)
    // - stage の初期化 -
    await this.initTemplate();
    if (!this.wrapperStage) return;
    this.wrapperStage.stage.snapToPixelEnabled = true;
    this.wrapperStage.stage.update();
  }

  async activateStage(kijshopCd: string, shopOrderId: string, orderId: string, initData: PrintTrimMenuType) {
    this.kijshopCd = kijshopCd;
    this.shopOrderId = shopOrderId;
    this.orderId = orderId;
    // const currentAlbumPath = this.printManager.currentPrint?.indexes;
    // const orderPage = orderPages?.find((page) => isEqual(page?._indexes, currentAlbumPath));
    this.trimWebFontManager.initialize();
    this.trimFontManager.initialize();
    this.thumbImageCreator.initialize();
    this.thumbTempCreator.initialize();
    this.thumbTextCreator.initialize();
    // - TrimThumbManager -
    const albumData = this.printManager.currentPrint;// // - TrimPanZoomManager -
    if (!this.wrapperStage) return;

    // --- 特定の要素以外クリックでフォーカスを外す ---
    // TrimUiManager.ins.emit('r->t:image-guide-on/off', { mode: initData.modeAbleArea });
    // TrimUiManager.ins.emit('r->t:image-resize-in/out', { mode: initData.modeInOut });
    // TrimUiManager.ins.emit('r->t:center-line', { display: initData.display });
    // TrimUiManager.ins.emit('t->r:frame-fit:push', { fitNum: initData.fitNum });
    // TrimUiManager.ins.emit('r->t:change-operation-cursor', { mode: initData.modeCursor });
    // TrimUiManager.ins.emit('r->t:transparent-additional', {
    //   type: initData.additionalShow, callback: () => {
    //   },
    // });
    // TrimUiManager.ins.emit('t->r:show-toast', { isToast: this.isFit, target: this.stage! });

    // -- ステージの再描画処理 --
    // NOTE: RAF(RequestAnimationFrame)モード。60FPS
    // createjs.Ticker.timingMode = createjs.Ticker.RAF
    // createjs.Ticker.addEventListener('tick', this.wrapperStage);
    // if (albumData && !albumData?.restoreMount) {
    //   createjs.Ticker.addEventListener('tick', this.wrapperStage);
    // }
    // createjs.Ticker.addEventListener('tick', () => {
    //   this.wrapperStage?.update();
    //   // this.stage?.update();
    // });
    // this.panZoomManager.getOperationMode === 'pan-zoom' ?
    //   this.editableSideTool.lock()
    //   : this.editableSideTool.unlock();
  }

  deactivateStage(container: HTMLDivElement) {
    // this.editableSideTool.unlock();
    if (!this.canvas) {
      throw new Error('this.canvas is null !!');
    }
    this.destroy();
    try {
      container.removeChild(this.canvas);
      this.canvas.height = 0;
      this.canvas.width = 0;
      this.canvas.remove();
    } catch {
    }
  }

  getCanvasEle() {
    if (!this.canvas) {
      throw new Error('this.canvas is null !!');
    }
    return this.canvas;
  }

  removeCanvasData() {
    if (!this.canvas) {
      throw new Error('this.canvas is null !!');
    }
    this.destroy();
    this.canvas.height = 0;
    this.canvas.width = 0;
    this.canvas.remove();
  }

  createCanvasEle() {
    // テンプレートのサイズ
    // canvas作成
    this.canvas.id = this.CANVAS_ID;
    const print = this.printManager.currentPrint;
    const base = print?.base;
    const template = base?.getImageWindow();
    if (!print || !base || !template) {
      throw new Error('template not found !!!!')
    }
    const fills = base.getFillWindow();
    const edgeTmp = this.printManager.getEdge(template.virtual.wh, fills);
    // NOTE: フチなしの商品と白フチ商品の判別がテンプレートではできないためハードコーディング
    const isNoEdge = print.item.productData?.meta?.borderType === NO_EDGE_TYPE;
    // テンプレートのサイズをcanvasのサイズにする
    this.canvas.width = ThumbCreatorManager.CANVAS_W;
    this.canvas.height = ThumbCreatorManager.CANVAS_H;
    this.templateVirtual.w = template.virtual.wh.width;
    this.templateVirtual.h = template.virtual.wh.height;

    // this.templateBaseVirtual.w = edgeTmp ? edgeTmp.virtual.wh.width : template.virtual.wh.width;
    // this.templateBaseVirtual.h = edgeTmp ? edgeTmp.virtual.wh.height : template.virtual.wh.height;
    this.templateBaseVirtual.w = isNoEdge ? template.virtual.wh.width : template.virtual.wh.width + (template.virtual.pos.x * 2);
    this.templateBaseVirtual.h = isNoEdge ? template.virtual.wh.height : template.virtual.wh.height + (template.virtual.pos.y * 2);

    this.STAGE_CONTAINER_X = ThumbCreatorManager.STAGE_CONTAINER_BASE_X - this.templateBaseVirtual.w/2
    this.STAGE_CONTAINER_Y = ThumbCreatorManager.STAGE_CONTAINER_BASE_Y - this.templateBaseVirtual.h/2
    // this.templateReal.w = Number(tempSize.$.width);
    // this.templateReal.h = Number(tempSize.$.height);
  }

  // - templateの初期化 -
  private async initTemplate() {
    if (!this.canvas) {
      throw new Error('There is no canvas !!');
    }
    // - createJSのCanvas -
    this.wrapperStage = new TrimCjStage(this.canvas);
    // - event判定用の背景 -
    const blackBack = new TrimCjShape();
    blackBack.name = CJ_BGIMAGE_NAME.blackback;
    blackBack.graphics.f('#000').dr(0, 0, ThumbCreatorManager.CANVAS_W, ThumbCreatorManager.CANVAS_H);
    this.wrapperStage.addChild(blackBack);
    // - createJSのCanvas -
    this.stage = new TrimCjContainer();
    this.stage.x = this.STAGE_CONTAINER_X;
    this.stage.y = this.STAGE_CONTAINER_Y;
    this.stage.name = CJ_CONTAINER_NAME.stage;
    this.wrapperStage.addChild(this.stage);

    // - 画像の取得先 -
    this.initIns(this.stage);
    this.initDi();

    this.thumbTempCreator.createEdge();
    this.thumbTempCreator.createBgImage();
    await this.thumbTempCreator.createPhotoArea();
    this.isCompThumb && await this.thumbTextCreator.createDateText();
    this.thumbTempCreator.createGuide();

    // await this.thumbTempCreator.createStageMask();
    if (!this.printManager.currentPrint?.restoreMount) {
      TrimUiManager.ins.emit('t->r:wait-loading2', { message: '' });
    }
  }

  // - インスタンス用意 -
  private initIns(stage: TrimCjContainer) {
    this.thumbImageCreator = new ThumbImageCreator(stage);
    this.thumbTempCreator = new ThumbTempCreator(stage);
    this.thumbTextCreator = new ThumbTextCreator(stage);
  }

  // - インスタンス用意 -
  private updateIns(stage: TrimCjContainer, path: PathType, url: string) {
    this.thumbImageCreator.update(stage);
    this.thumbTempCreator.update(stage);
  }

  // - インスタンスのDI -
  private initDi() {
    this.thumbImageCreator.di(
      this.thumbTempCreator,
      this.printManager,
      this,
    );
    this.thumbTextCreator.di(
      this.printManager,
      this,
    );
    this.thumbTempCreator.di(
      this.printManager,
      this.thumbImageCreator,
      this.additionalManager,
      this.thumbTextCreator,
      this
    );
    this.trimWebFontManager.di(
      TrimUiManager.ins,
    )
    this.trimFontManager.di(
      TrimUiManager.ins,
    )
    this.trimWebFontManager.initialize();
    this.trimFontManager.initialize();
    this.thumbImageCreator.initialize();
    this.thumbTempCreator.initialize();
    this.thumbTextCreator.initialize();
  }

  private deleteCanvasEle(container: HTMLDivElement) {
    if (this.canvas) {
      container.removeChild(this.canvas);
      // this.canvas = null;
    }
  }

}
